import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import { IReviewDetails } from '@pharmaplan/common/models/Models';
import strings from '../../../localization';
import styles from './styles';
import WithSkeleton from '../../common/WithSkeleton';

interface IReviewDetailsComp {
  reviewDetails: IReviewDetails | undefined;
  successAction: string;
}

const ReviewDetails: FC<IReviewDetailsComp> = ({
  reviewDetails,
  successAction,
}) => {
  const {
    confirmedBookings: noOfContracts,
    cancellations,
    cancellationPercent,
    totalBookings = 0,
    questionValues = [],
    arrivals,
  } = reviewDetails ?? {};

  const SkeletonBox = WithSkeleton({
    successAction,
    variant: 'text',
  })(Box);

  const SkeletonTypography = WithSkeleton({
    successAction,
    variant: 'text',
  })(Typography);

  return (
    <>
      <Box sx={styles.container}>
        <SkeletonBox sx={styles.labelContainer}>
          <Typography sx={[styles.label, styles.commonColor, styles.flexMax]}>
            {strings.noOfContract}
          </Typography>
          <Typography
            sx={[styles.label, styles.commonColor, styles.bold, styles.flexMax]}
          >
            {noOfContracts}
          </Typography>
        </SkeletonBox>
        <SkeletonBox sx={styles.labelContainer}>
          <Typography sx={[styles.label, styles.commonColor, styles.flexMax]}>
            {strings.cancellations}
          </Typography>
          <Typography
            sx={[
              styles.label,
              styles.commonColor,
              styles.bold,
              styles.flexMax,
              styles.wrapText,
            ]}
          >
            {cancellations}
            {' '}
            (
            {cancellationPercent}
            %
            {' '}
            {strings.formatString(strings.basedOnNBookings, totalBookings)}
            )
          </Typography>
        </SkeletonBox>
      </Box>

      <Box sx={styles.container}>
        <SkeletonTypography sx={[styles.title, styles.bold]}>
          {strings.punctuality}
        </SkeletonTypography>
        <Box sx={styles.arrivalContainer}>
          {questionValues.map((item) => {
            const { key, value } = item ?? {};
            return (
              <SkeletonTypography
                key={key}
                sx={[styles.commonColor, styles.arrival]}
              >
                {value}
                :
                {' '}
                {arrivals?.[key] ?? '-'}
              </SkeletonTypography>
            );
          })}
        </Box>
      </Box>
    </>
  );
};

export default ReviewDetails;
